export var TRANSPARENT = 'transparent';
export var TRANSPARENT_GREY_1000 = '#141414cc';
export var AIRTEL_RED = '#d40000';
export var BLACK = '#000000';
export var BLUE_GREY = '#374150';
export var DARK_GREY = '#2d2d2d';
export var LIGHT_GREY = '#dcdcdc';
export var WHITE = '#ffffff';
export var BLUE_GREY_100 = '#f3f4f7';
export var BLUE_GREY_200 = '#dadfe7';
export var BLUE_GREY_300 = '#c2cad6';
export var BLUE_GREY_400 = '#a9b5c6';
export var BLUE_GREY_500 = '#7b8ba3';
export var BLUE_GREY_600 = '#52627a';
export var BLUE_GREY_700 = '#394556';
export var BLUE_GREY_800 = '#29313d';
export var BLUE_GREY_900 = '#1d222b';
export var BLUE_GREY_1000 = '#101418';
export var BLACK_100 = '#f6f6f6';
export var BLACK_200 = '#eaeaea';
export var BLACK_300 = '#d4d5d6';
export var BLACK_400 = '#bfc0c1';
export var BLACK_500 = '#a0a2a4';
export var BLACK_600 = '#87888a';
export var BLACK_700 = '#696b6f';
export var BLACK_800 = '#3e4146';
export var BLACK_900 = '#292c31';
export var LILAC_100 = '#fbfbff';
export var LILAC_200 = '#f4f5ff';
export var LILAC_300 = '#ecedff';
export var LILAC_400 = '#e3e5ff';
export var LILAC_500 = '#d2d5f6';
export var LILAC_600 = '#cdd0f5';
export var LILAC_700 = '#c3c7f3';
export var LILAC_800 = '#b9bef1';
export var LILAC_900 = '#afb5ef';
export var BLUE_100 = '#cddffa';
export var BLUE_200 = '#9cbff6';
export var BLUE_300 = '#6a9ef1';
export var BLUE_400 = '#397eed';
export var BLUE_500 = '#075ee8';
export var BLUE_600 = '#064bba';
export var BLUE_700 = '#04388b';
export var BLUE_800 = '#03265d';
export var BLUE_900 = '#01132e';
export var GREEN_100 = '#d1efdc';
export var GREEN_200 = '#a3dfb9';
export var GREEN_300 = '#54c47e';
export var GREEN_400 = '#34b965';
export var GREEN_500 = '#18af50';
export var GREEN_600 = '#159a46';
export var GREEN_700 = '#12853d';
export var GREEN_800 = '#0f7033';
export var GREEN_900 = '#0d632e';
export var YELLOW_100 = '#ffeece';
export var YELLOW_200 = '#ffe1aa';
export var YELLOW_300 = '#ffd27e';
export var YELLOW_400 = '#ffbb3f';
export var YELLOW_500 = '#ffad16';
export var YELLOW_600 = '#ec9900';
export var YELLOW_700 = '#db8e00';
export var YELLOW_800 = '#c38002';
export var YELLOW_900 = '#ad7305';
export var RED_100 = '#ffcece';
export var RED_200 = '#ffaaaa';
export var RED_300 = '#ff8080';
export var RED_400 = '#eb4f4f';
export var RED_500 = '#d73737';
export var RED_600 = '#b22020';
export var RED_700 = '#9d1c1c';
export var RED_800 = '#871818';
export var RED_900 = '#781515';
export var GRADIENT_SUCCESS_START = '#a3dfb9';
export var GRADIENT_SUCCESS_END = '#18af50';
export var GRADIENT_WARNING_START = '#ffe1aa';
export var GRADIENT_WARNING_END = '#ffad16';
export var GRADIENT_DANGER_START = '#ffaaaa';
export var GRADIENT_DANGER_END = '#d73737';
export var GRADIENT_RETRO_START = '#ff57bc';
export var GRADIENT_RETRO_END = '#2b2bff';
export var GRADIENT_SUNRISE_START = '#ff7957';
export var GRADIENT_SUNRISE_END = '#ffca82';
export var GRADIENT_DODGER_BLUE_START = '#a784ef';
export var GRADIENT_DODGER_BLUE_CENTER = '#559efb';
export var GRADIENT_DODGER_BLUE_END = '#5ed8df';
export var GRADIENT_SEA_GREEN_START = '#c2ffe2';
export var GRADIENT_SEA_GREEN_CENTER = '#75def5';
export var GRADIENT_SEA_GREEN_END = '#7b9fff';
export var GRADIENT_LUSH_START = '#67b044';
export var GRADIENT_LUSH_END = '#daef84';
export var GRADIENT_COOL_SKY_START = '#0077f5';
export var GRADIENT_COOL_SKY_END = '#18d5ff';
export var GRADIENT_PURPLIN_START = '#9462ff';
export var GRADIENT_PURPLIN_END = '#d1a3ff';
export var GRADIENT_PREMIUM_DARK_START = '#0b0b0b';
export var GRADIENT_PREMIUM_DARK_END = '#565656';
export var GRADIENT_MOUNTAIN_ROCK_START = '#0b0b0b';
export var GRADIENT_MOUNTAIN_ROCK_END = '#d6d6d6';
export var GRADIENT_SIN_CITY_START = '#f43640';
export var GRADIENT_SIN_CITY_END = '#fe9ca9';
export var GRADIENT_PEACH_START = '#fcedd8';
export var GRADIENT_PEACH_END = '#f5c5c6';
export var GRADIENT_FLAME_START = '#fdf0c0';
export var GRADIENT_FLAME_END = '#fcc5a5';
export var GRADIENT_MINT_GREEN_START = '#cff9d8';
export var GRADIENT_MINT_GREEN_END = '#f3eea0';
export var GRADIENT_AQUA_SPLASH_START = '#c6f3f2';
export var GRADIENT_AQUA_SPLASH_END = '#b5c9fd';
export var GRADIENT_ALICE_BLUE_START = '#bfd7ff';
export var GRADIENT_ALICE_BLUE_END = '#fbd3f4';
export var GRADIENT_STELLAR_START = '#e0f0ff';
export var GRADIENT_STELLAR_END = '#e5e3ff';
export var GRADIENT_MANTLE_START = '#f5e5f8';
export var GRADIENT_MANTLE_END = '#e0e1ff';
export var WATERSPOUT = '#94c5f2';
export var JASMINE = '#ffdf83';
export var SPANISH_PINK = '#ffbaba';
export var TROPICAL_INDIGO = '#a58fff';
export var FRENCH_SKY_BLUE = '#74aeff';
export var PASTEL_ORANGE = '#ffbc57';
export var NEW_YORK_PINK = '#de8579';
export var MEDIUM_SLATE_BLUE = '#7c79ff';
export var PALE_MAGENTA = '#ff8ff4';
export var LIGHT_CORAL = '#ff7575';
export var MEDIUM_AQUAMARINE = '#6ad9ab';
export var ROYAL_VIOLET = '#733ae9';
export var TIER_SILVER = '#bababa';
export var TIER_GOLD = '#d5a358';
export var TIER_PLATINUM = '#313f46';
export var TIER_BLACK = '#181818';